import { Divider, Flex, Spacing, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { EarlyPaymentDiscountMentionsGroup } from './elements/EarlyPaymentDiscountMentionsGroup'

export const LegalMentionsEarlyPaymentDiscount = () => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Text>{t('settings.organization.external_invoice.legal_mentions.modal.early_payment_discount.description')}</Text>
      <Divider />
      <EarlyPaymentDiscountMentionsGroup />
    </Flex>
  )
}
